
import { Component, Prop, State, Vue } from 'nuxt-property-decorator';
import SanityBlockContent from '~/components/Sanity/SanityBlockContent.vue';
import {
  ISanityDocuments,
  ProjectPageVariation,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import { IProfileState } from '~/store/profile/types';
import SignUp from '~/components/UIComponents/SignUp.vue';
import SignUpForAlertsBtn from '~/components/UIComponents/SignUpForAlertsBtn.vue';
import ProjectItemsForSale from './ProjectItemsForSale.vue';

@Component({
  components: {
    ProjectItemsForSale,
    SanityBlockContent,
    SignUp,
    SignUpForAlertsBtn,
  },
})
export default class ProjectSaleTab extends Vue {
  @Prop(Boolean) readonly isSaleLive!: boolean;
  @Prop(Boolean) readonly loading!: boolean;
  @Prop(Object) readonly doc!: ISanityDocuments[SanityDocumentSchema.PROJECT];

  @State((state: IProfileState) => state.user.loggedIn, {
    namespace: 'profile',
  })
  readonly loggedIn!: boolean;

  isSubscribed = false;
  variations = ProjectPageVariation;

  get variation() {
    return this.$sanityLookup.getSiteConfig()?.data?.projectPageVariation;
  }

  get slug() {
    return this.doc?.slug || '';
  }

  get saleText() {
    return this.doc?.saleText;
  }

  get successMessage() {
    return this.doc?._type
      ? this.$t(`components.signUp.uaPage.signupSuccessMessageWithSchema`, {
          schema: this.$sanityLookup.translateSchema(
            this.doc._type as SanityDocumentSchema,
          ),
        })
      : this.$t(`components.signUp.uaPage.signupSuccessMessage`);
  }
}
